import { getGIA as i } from "./index26.js";
import { getNIA as n } from "./index38.js";
const f = (t) => {
  const r = i(t);
  return r === 0 ? 0 : n(t) / r;
};
export {
  f as getEfficiency
};
//# sourceMappingURL=index17.js.map
